import React, { memo } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { PATHS } from './config';

/**
 * `/career/skills/:slug` → `/career/skills?skill=<slug>` (ТЗ 0070).
 *
 * Отдельный компонент, а не `LegacyRedirect`, потому что переезд идёт в
 * обратную сторону: параметр ПУТИ становится параметром ЗАПРОСА. `<Navigate>`
 * этого не умеет вовсе, а `generatePath` умеет ровно обратное — подставить
 * параметр в путь.
 *
 * Карта навыков стала одним экраном, и адрес одного навыка теперь его
 * состояние, а не отдельная страница: иначе выбор узла означал бы переход, а
 * «назад» — уход с карты вместо снятия выбора.
 *
 * 🔴 `search` и `hash` переносятся: ссылка из письма
 * `/career/skills/docker?utm_source=mail` без этого приехала бы на голую карту,
 * и человек прочитал бы это как «ссылка протухла».
 *
 * 🔴 `replace` — иначе «Назад» возвращает на старый адрес, тот снова
 * редиректит вперёд, и кнопка перестаёт работать насовсем.
 *
 * ⚠️ Ни одного `t()` здесь быть не должно: `src/router` не входит в корни
 * сканера locale-теста, и ключ отсюда не попал бы под проверку.
 */
export const SkillSlugRedirect = memo(() => {
  const { slug } = useParams();
  const { search, hash } = useLocation();

  const params = new URLSearchParams(search);
  if (slug) params.set('skill', slug);

  const query = params.toString();
  return <Navigate replace to={`${PATHS.careerSkills}${query ? `?${query}` : ''}${hash}`} />;
});
